import { createSelector } from 'reselect';

export const getNetworkPerformance = (state) => state.networkPerformance;

export const getNetworkPerformanceDateRange = createSelector(
  getNetworkPerformance,
  ({ dateRange }) => dateRange
);

export const getNetworkPerformanceStudios = createSelector(
  getNetworkPerformance,
  ({ studioIds }) => studioIds
);

export const getNetworkPerformanceGranularity = createSelector(
  getNetworkPerformance,
  ({ granularity }) => granularity
);

export const getNetworkPerformanceDashboard = createSelector(
  getNetworkPerformance,
  ({ dashboard }) => dashboard
);

export const isNetworkPerformanceLoading = createSelector(
  getNetworkPerformance,
  ({ loading }) => loading
);

export const isNetworkPerformanceDownloading = createSelector(
  getNetworkPerformance,
  ({ downloading }) => downloading
);

export const getNetworkPerformanceError = createSelector(
  getNetworkPerformance,
  ({ error }) => error
);
